// Tolerant parser for the partial JSON streamed during generation. Display-only: if a
// frame can't be repaired it returns null and the caller keeps the last good object. The
// authoritative complete object always arrives in the stream's final "done" event.
export function parsePartialJson(input) {
  if (!input || typeof input !== 'string') return null;
  // Intentional no-op catch: a partial stream frame is expected to be invalid JSON; fall through to repair().
  try { return JSON.parse(input); } catch { /* repair below */ }
  const repaired = repair(input);
  if (repaired == null) return null;
  try { return JSON.parse(repaired); } catch { return null; }
}

function repair(s) {
  const closers = [];
  let inStr = false;
  let esc = false;
  for (let i = 0; i < s.length; i++) {
    const c = s[i];
    if (esc) { esc = false; continue; }
    if (c === '\\') { if (inStr) esc = true; continue; }
    if (c === '"') { inStr = !inStr; continue; }
    if (inStr) continue;
    if (c === '{') closers.push('}');
    else if (c === '[') closers.push(']');
    else if (c === '}' || c === ']') closers.pop();
  }

  let out = s;
  if (inStr) out += '"';              // close an open string literal
  out = out.replace(/\s+$/, '');

  // Drop a dangling key with no value yet:  …,"foo":   or   …,"foo"
  if (/:\s*$/.test(out)) {
    out = out.replace(/,?\s*"(?:[^"\\]|\\.)*"\s*:\s*$/, '');
  } else if (/(?:[,{[])\s*"(?:[^"\\]|\\.)*"$/.test(out)) {
    out = out.replace(/,?\s*"(?:[^"\\]|\\.)*"$/, '');
  }
  out = out.replace(/,\s*$/, '');     // strip a trailing comma

  for (let i = closers.length - 1; i >= 0; i--) out += closers[i];
  return out;
}
